import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import statusCodes from '../statusCodes';

var AppIdAlreadySet = /*#__PURE__*/function (_Error) {
  _inherits(AppIdAlreadySet, _Error);

  var _super = _createSuper(AppIdAlreadySet);

  function AppIdAlreadySet(appId) {
    var _this;

    _classCallCheck(this, AppIdAlreadySet);

    for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      params[_key - 1] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this, appId].concat(params));
    _this.name = 'AppIdAlreadySet';
    _this.message = 'Application ID already set.';
    _this.status = statusCodes['Conflict'];
    _this.appId = appId;
    return _this;
  }

  return AppIdAlreadySet;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var AppIdMustBeString = /*#__PURE__*/function (_Error2) {
  _inherits(AppIdMustBeString, _Error2);

  var _super2 = _createSuper(AppIdMustBeString);

  function AppIdMustBeString() {
    var _this2;

    _classCallCheck(this, AppIdMustBeString);

    for (var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      params[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(params));
    _this2.name = 'AppIdMustBeString';
    _this2.message = 'Application ID must be a string.';
    _this2.status = statusCodes['Bad Request'];
    return _this2;
  }

  return AppIdMustBeString;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var AppIdMissing = /*#__PURE__*/function (_Error3) {
  _inherits(AppIdMissing, _Error3);

  var _super3 = _createSuper(AppIdMissing);

  function AppIdMissing() {
    var _this3;

    _classCallCheck(this, AppIdMissing);

    for (var _len3 = arguments.length, params = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      params[_key3] = arguments[_key3];
    }

    _this3 = _super3.call.apply(_super3, [this].concat(params));
    _this3.name = 'AppIdMissing';
    _this3.message = 'Application ID missing.';
    _this3.status = statusCodes['Bad Request'];
    return _this3;
  }

  return AppIdMissing;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var AppIdCannotBeBlank = /*#__PURE__*/function (_Error4) {
  _inherits(AppIdCannotBeBlank, _Error4);

  var _super4 = _createSuper(AppIdCannotBeBlank);

  function AppIdCannotBeBlank() {
    var _this4;

    _classCallCheck(this, AppIdCannotBeBlank);

    for (var _len4 = arguments.length, params = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      params[_key4] = arguments[_key4];
    }

    _this4 = _super4.call.apply(_super4, [this].concat(params));
    _this4.name = 'AppIdCannotBeBlank';
    _this4.message = 'Application ID cannot be blank.';
    _this4.status = statusCodes['Bad Request'];
    return _this4;
  }

  return AppIdCannotBeBlank;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var WebCryptoUnavailable = /*#__PURE__*/function (_Error5) {
  _inherits(WebCryptoUnavailable, _Error5);

  var _super5 = _createSuper(WebCryptoUnavailable);

  function WebCryptoUnavailable() {
    var _this5;

    _classCallCheck(this, WebCryptoUnavailable);

    for (var _len5 = arguments.length, params = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      params[_key5] = arguments[_key5];
    }

    _this5 = _super5.call.apply(_super5, [this].concat(params));
    _this5.name = 'WebCryptoUnavailable';
    _this5.message = 'The WebCrypto API is unavailable. Please make sure your website uses https.';
    _this5.status = statusCodes['Bad Request'];
    return _this5;
  }

  return WebCryptoUnavailable;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var UpdateUserHandlerMustBeFunction = /*#__PURE__*/function (_Error6) {
  _inherits(UpdateUserHandlerMustBeFunction, _Error6);

  var _super6 = _createSuper(UpdateUserHandlerMustBeFunction);

  function UpdateUserHandlerMustBeFunction() {
    var _this6;

    _classCallCheck(this, UpdateUserHandlerMustBeFunction);

    for (var _len6 = arguments.length, params = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      params[_key6] = arguments[_key6];
    }

    _this6 = _super6.call.apply(_super6, [this].concat(params));
    _this6.name = 'UpdateUserHandlerMustBeFunction';
    _this6.message = 'Update user handler must be a function.';
    _this6.status = statusCodes['Bad Request'];
    return _this6;
  }

  return UpdateUserHandlerMustBeFunction;
}( /*#__PURE__*/_wrapNativeSuper(Error));

export default {
  AppIdAlreadySet: AppIdAlreadySet,
  AppIdMustBeString: AppIdMustBeString,
  AppIdMissing: AppIdMissing,
  AppIdCannotBeBlank: AppIdCannotBeBlank,
  WebCryptoUnavailable: WebCryptoUnavailable,
  UpdateUserHandlerMustBeFunction: UpdateUserHandlerMustBeFunction
};